import React from 'react'
import glamorous from 'glamorous'
import Table from 'antd/lib/table'
import Row from 'antd/lib/row'
import Col from 'antd/lib/col'
import get from 'lodash/fp/get'
import reduce from 'lodash/fp/reduce'
import { formatNumber } from "../../shared/constants";
import { PR_EXEMP_PurchaseQuery, CompanyByIdQuery } from 'qgst-gql-queries/web/data.json'
import { gql, graphql, compose } from 'react-apollo'
import { connect } from 'react-redux'
import { Root, ContentWrapper as Content } from '../../shared/styles'
const row_style = { border: 'solid 1px #e8e8e8', padding: '10px', margin: '1px' };
const { ColumnGroup, Column } = Table
const SRow = glamorous(Row)({ margin: '15px 0',})

const PurchaseRegister = props => {
  return (
    <Root>
      <Content>
        <SRow gutter={24} style={row_style}>
          <Col span="24">
            Total Exempted Amount:{' '}
            {reduce((curr, next) => {
              curr = parseFloat(curr) + parseFloat(next.expt_amt, 2);
              var temp = parseFloat(curr);
              temp = parseFloat(temp).toFixed(2);
              return(temp)}, 0)(props.pr_exemp_masters)}
          </Col>
        </SRow>
        <Table dataSource={props.pr_exemp_masters} bordered rowKey="id" loading={props.loading} title={() => 'NIL/EXEMP Purchases'}>
          <Column title="Supply Type" dataIndex="supply_type" key="supply_type" />
          <ColumnGroup title="Amount">
            <Column title="Composition Dealer" dataIndex="comp_amt" key="comp_amt" render={val => <p>{props.formatNumber(val === null ? 0 : val)}</p>}/>
            <Column title="Nil Rated Supply" dataIndex="nil_amt" key="nil_amt" render={val => <p>{props.formatNumber(val === null ? 0 : val)}</p>}/>
            <Column title="Exempt Supply" dataIndex="expt_amt" key="expt_amt" render={val => <p>{props.formatNumber(val === null ? 0 : val)}</p>}/>
            <Column title="Non GST Supply" dataIndex="ngsup_amt" key="ngsup_amt" render={val => <p>{props.formatNumber(val === null ? 0 : val)}</p>}/>
          </ColumnGroup>
        </Table>
      </Content>
    </Root>
  )
}

class PurchaseRegisterContainer extends React.Component
{
  constructor(props)
  {
    super(props)
    console.log(props);
    var d = new Date();
    var n = d.getMonth();
    var y = d.getYear();
    var curyear = 1900 + y;
    var nextyear = curyear + 1 - 2000;
    var year =  curyear + '-' + nextyear;
    this.state = {
      visibleModal: null,
      finMonth: n+1,
      finYear: year,
      curFinMonth: n+1,
      curFinYear: year,
    }
    this.props.data.refetch()
  }
  getTaxPeriod = () => {
	  return this.state.finMonth;
  }
  getFinYear = () => {
	  return this.state.finYear;
  }

  showModal = async id => {
    this.setState({ visibleModal: id })
  }
  hideModal = () => {
    this.setState({ visibleModal: null })
  }
  changeSelectedFinancialMonth = name => {
    this.props.changeSelectedFinancialMonth(name)
  }
  render() {
    var tableLoading = false;
    if (this.props.data.networkStatus === 4) { tableLoading = false; }
    else if (this.props.data.networkStatus === 7) { tableLoading = false; }
    else if (this.props.data.networkStatus === 1) { tableLoading = true; }
    return (
      <PurchaseRegister
        pr_exemp_masters={get('viewer.pr_exemp_masters.edges')(this.props.data)}
        role={get('company.role', this.props)}
        finMonth={this.state.finMonth}
		    finYear={this.state.finYear}
        loading={tableLoading}
        showModal={this.showModal}
        hideModal={this.hideModal}
        formatNumber={formatNumber}
        visibleModal={this.state.visibleModal}
        isSR={this.props.isSR}
      />
    )
  }
}

const queryConfig = {
  options: props => ({
    variables: {
      companyId: props.selectedCompany,
      // isSR: props.isSR,
      type: 'prexemp',
      finmonth: props.finMonth.toString(),
      finyear: props.finYear,
    },
  }),
}
const companyQueryConfig = {
  options: props => ({
    variables: {
      companyId: props.selectedCompany,
      finYear: props.finYear,
      finMonth: props.finMonth,
    },
  }),
  props: ({ data }) => {
    return {
      company: get('viewer.company', data),
      isEdit: true,
    }
  },
}

const mapStateToProps = state => {
  return {
    selectedCompany: state.local.selectedCompany,
    finMonth: state.local.finMonth,
    finYear: state.local.finYear,
  }
}
export default compose(
  connect(mapStateToProps),
  graphql(gql(PR_EXEMP_PurchaseQuery), queryConfig),
  graphql(gql(CompanyByIdQuery), companyQueryConfig)
)(PurchaseRegisterContainer)
